<template>
  <div class="chart-dialog">
    <el-dialog
      title="学生成绩对比图"
      :visible.sync="chartDialogShow"
      width="50%"
      :before-close="dialogClose"
    >
      <!-- 柱状图 -->
      <div
        id="myChart"
        ref="chart"
        style="height: 500px; width: 96%; margin: 0 auto"
      ></div>
    </el-dialog>
  </div>
</template>

<script>
import * as echarts from "echarts";
export default {
  props: ["chartDialogShow", "studentList", "examInfoList"],
  data() {
    return {
      myChart: null,
    };
  },
  watch: {
    chartDialogShow(newVal, oldVal) {
      if (newVal) {
        setTimeout(() => {
          // 初始化柱状图
          this.initChart();
        }, 200);
      }
    },
  },
  beforeDestroy() {
    this.clearChart();
  },
  methods: {
    // 销毁图例
    clearChart() {
      if (
        this.myChart != null &&
        this.myChart != undefined &&
        this.myChart != ""
      ) {
        this.myChart.dispose();
      }
    },
    // 关闭弹出窗口
    dialogClose() {
      this.$emit("update:chartDialogShow", false);
      this.clearChart();
    },
    initChart() {
      this.myChart = echarts.init(document.getElementById("myChart"));
      let sourceList = [["product"]];
      let seriesList = [];

      this.studentList[0].examInfoScoreList.forEach((item) => {
        sourceList.push([item.title + item.subTitle]);
      });

      this.studentList.forEach((item) => {
        sourceList[0].push(item.studentName);
        sourceList[1].push(item.examInfoScoreList[0].avgScore);
        sourceList[2].push(item.examInfoScoreList[1].avgScore);
        seriesList.push({
          type: "bar",
        });
      });

      // console.log("sourceList：", sourceList, this.studentList);

      const option = {
        legend: {},
        tooltip: {},
        dataset: {
          source: sourceList,
        },
        xAxis: { type: "category" },
        yAxis: {},
        // Declare several bar series, each will be mapped
        // to a column of dataset.source by default.
        series: seriesList,
      };

      // 指定图表的配置项和数据
      this.myChart.setOption(option);
      //随着屏幕大小调节图表
      window.addEventListener("resize", () => {
        this.myChart.resize();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./barChartDialog.scss";
</style>